<div class="pause-wrapper">
  <!-- <h1 class="pause-icon">⏸</h1> -->
  <!-- new -->
  <img src="../../../../assets/images/pause-bottom.png" alt="" class="pause-img">
  <!-- end new -->
  <h1 class="pause-syndicate-title"> {{'pause-syndicate.Pausing' | translate}}</h1>
  <!-- <p>{{'pause-syndicate.break' | translate}}</p>
  <p>
    {{'pause-syndicate.billing' | translate}} <span class="date">{{ getResumeDate() }}</span>
  </p> -->
  <p class="although">{{'pause-syndicate.although payment' | translate}}</p>
  <p class="normal-billing">{{'pause-syndicate.normal billing' | translate}} <span class="date">{{ getResumeDate()
  }}</span> {{'pause-syndicate.if confirmed' | translate}}</p>
  <ion-button color="secondary" expand="block" class="capsule-btn" type="submit"
    (click)="startSpinner();pauseSyndicate();">
    @if (!spinnerAnimation && proceed) {
      <span> {{'pause-syndicate.confirm' | translate}}</span>
    }
    @if (spinnerAnimation) {
      <div class="spinners">
        <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="40">
        </mat-progress-spinner>
      </div>
    }
    @if (!proceed) {
      <mat-icon [@bounceIn] class="tick-mark">{{'pause-syndicate.done' | translate}}</mat-icon>
    }
  </ion-button>

  <p class="arrow-back" (click)="closePauseSyndicateDialog(false)"><span class="back">←</span> {{'pause-syndicate.close'
| translate}}</p>
</div>